// src/components/Layout/HideOnScroll.jsx
import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { Box } from "@metrea-ui/v2";
import { useScrollDirection } from "src/hooks/useScrollDirection";

/**
 * Local hide-on-scroll helper for the direct-v2 app shell.
 *
 * Behavior:
 * - Hide when scrolling down
 * - Show immediately when scrolling up
 * - Always show at top
 */
const HideOnScroll = ({ children, isOnTop, scrollContainerRef }) => {
	const { isScrollingUp, isAtTop } = useScrollDirection(scrollContainerRef);

	const shouldShow = isAtTop || isScrollingUp;

	// Preserve existing DOM side-effect EXACTLY
	useEffect(() => {
		const el = document.querySelector(".main-header__container");
		if (!el) return;

		if (isOnTop) el.classList.remove("onTop");
		else el.classList.add("onTop");
	}, [isOnTop, children]);

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			right={0}
			zIndex="sticky"
			transform={shouldShow ? "translateY(0)" : "translateY(-100%)"}
			transition="transform 0.25s ease-out"
		>
			{children}
		</Box>
	);
};

HideOnScroll.propTypes = {
	children: PropTypes.element.isRequired,
	isOnTop: PropTypes.bool,
	scrollContainerRef: PropTypes.shape({ current: PropTypes.any }),
};

export default HideOnScroll;
